import {
    Alert,
    Collapse,
    Dropdown,
    Modal,
    Tab,
    Tooltip,
    Popover
} from 'bootstrap';
import AOS from 'aos';
import './plugins/gridzy.min.js';
import ModuloBox from './plugins/modulobox.js';
import Masonry from 'masonry-layout';
import mixitup from 'mixitup';
import axios from 'axios';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fade';
import 'flickity-fullscreen';
import confetti from 'canvas-confetti';
import * as FilePond from "filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";

import './bouwinfodays-form';

AOS.init();

if(document.getElementById('application-form')) {
    FilePond.registerPlugin(FilePondPluginFileValidateType);
    FilePond.registerPlugin(FilePondPluginFileEncode);
    const filepond = FilePond.create(document.querySelector('.files'), {
        allowMultiple:                         true,
        instantUpload:                         false,
        required:                              true,
        acceptedFileTypes:                     ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        fileValidateTypeLabelExpectedTypesMap: {
            'image/png':                                                               '.png',
            'image/jpeg':                                                              '.jpg',
            'image/jpg':                                                               '.jpg',
            'application/pdf':                                                         '.pdf',
            'application/msword':                                                      '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx'
        },
        labelFileTypeNotAllowed:               'Onjuist bestandstype!',
        fileValidateTypeLabelExpectedTypes:    'Alleen {allButLastType} en {lastType} zijn togestaan',
        labelIdle:                             'Sleep je cv/motivatie hiernaartoe of <span class="filepond--label-action"> blader </span>'
    });

    let currentlySending        = false;
    const submitApplicationForm = (gRecaptchaResponse) => {
        const applicationForm = document.getElementById('application-form');
        if(currentlySending === false) {

            currentlySending       = true;
            const submitButton     = applicationForm.querySelector('[type="submit"]');
            submitButton.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
            submitButton.disabled  = true;
            submitButton.classList.add('disabled');

            const formData = new FormData(applicationForm);
            formData.append('g-recaptcha-response', gRecaptchaResponse)
            const validationAlert = document.getElementById('application-form-validation');

            document.querySelectorAll('.invalid-feedback').forEach((element) => {
                if(!element.classList.contains('d-none')) {
                    element.classList.add('d-none');
                }
            });

            document.querySelectorAll('.is-invalid').forEach((element) => {
                element.classList.remove('is-invalid');
            });

            validationAlert.classList.add('hidden');
            validationAlert.classList.remove('alert-danger');
            axios.post(applicationForm.action, formData).then((response) => {
                if(response.data.success) {
                    validationAlert.innerHTML = response.data.message;
                    validationAlert.classList.add('alert-success');
                    validationAlert.classList.remove('hidden');

                    applicationForm.innerHTML = '';
                } else {
                    currentlySending       = false
                    submitButton.innerHTML = 'Verstuur';
                    submitButton.disabled  = false;
                    submitButton.classList.remove('disabled');
                }
            }).catch((exception) => {
                if(exception.response.data.errors) {
                    for(let error in exception.response.data.errors) {
                        const el = applicationForm.querySelector('[name="' + error + '"]') || applicationForm.querySelector('#' + error);
                        if(el) {
                            el.classList.add('is-invalid');
                            if(el.parentNode.querySelector('.d-none') !== null) {
                                el.parentNode.querySelector('.d-none').classList.remove('d-none');
                            }
                        }
                    }
                }

                submitButton.classList.remove('disabled');
                submitButton.disabled  = false;
                submitButton.innerHTML = 'Verstuur bericht';
                currentlySending       = false;
            });
        }
    };

    window.submitApplicationForm = submitApplicationForm;
}

function frame(end = null) {
    // launch a few confetti from the left edge
    confetti({
        particleCount: 7,
        angle:         60,
        spread:        55,
        origin:        {
            x: 0,
            y: 0.9
        }
    });

    // and launch a few from the right edge
    confetti({
        particleCount: 7,
        angle:         120,
        spread:        55,
        origin:        {
            x: 1,
            y: 0.9
        }
    });

    // keep going until we are out of time
    if(Date.now() < end) {
        requestAnimationFrame(() => {
            frame(end);
        });
    } else {
        if(document.getElementById('60-year-overlay')) {
            document.getElementById('60-year-overlay').style.opacity = '0';
            setTimeout(() => {
                document.getElementById('60-year-overlay').remove();
            }, 300);
        }
    }
};

document.querySelectorAll('.launch-confetti').forEach((el) => {
    el.addEventListener('click', (event) => {
        event.preventDefault();

        let duration = 5 * 1000;
        let end      = Date.now() + duration;
        frame(end);
    });
});

// Page body
if(document.querySelector('.page-body')) {
    document.querySelectorAll('.page-body').forEach((item) => {
        item.querySelectorAll('img').forEach((image) => {
            image.classList.add('img-fluid');

            if(image.style.float === 'right') {
                image.style.marginLeft   = '15px';
                image.style.marginBottom = '15px';
                image.style.marginRight  = '0';
            } else if(image.style.float === 'left') {
                image.style.marginRight  = '15px';
                image.style.marginBottom = '15px';
                image.style.marginLeft   = '0';
            }
        });

        item.querySelectorAll('table').forEach((table) => {
            table.classList.add('table', 'table-striped', 'table-hover', 'table-sm');
            table.border = 0;

            if(!table.parentNode.classList.contains('table-responsive')) {
                let wrapper       = document.createElement('div');
                wrapper.className = 'table-responsive';

                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }

            table.querySelectorAll('tr').forEach((tr) => {
                tr.style.height = 'auto';
            });

            table.querySelectorAll('td').forEach((td) => {
                td.style.height = 'auto';
            });

            table.querySelectorAll('p').forEach((p) => {
                p.style.marginBottom = 0;
            });
        });

        item.querySelectorAll('iframe').forEach((iframe) => {
            if(iframe.src.match(/youtube|youtu/)) {
                if(!iframe.parentNode.classList.contains('ratio')) {
                    let wrapper       = document.createElement('div');
                    wrapper.className = 'ratio ratio-16x9';

                    iframe.parentNode.insertBefore(wrapper, iframe);
                    wrapper.appendChild(iframe);
                }
            }
        });
    });
}

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

// Enable BS Tooltips everywhere
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
tooltipTriggerList.map((tooltipTriggerEl) => {
    return new Tooltip(tooltipTriggerEl)
});

// Flickity
if(document.querySelector('.promotions-carousel')) {
    var flkty = new Flickity('.promotions-carousel', {
        cellAlign:       'left',
        contain:         true,
        wrapAround:      true,
        groupCells:      true,
        prevNextButtons: false
    });
}

// Flickity product images
if(document.querySelector('.product-images-main')) {
    var flktyA = new Flickity('.product-images-main', {
        arrowShape: '',
        fade:       true,
        pageDots:   false,
        fullscreen: false
    });
    var flktyB = new Flickity('.product-images-nav', {
        asNavFor:        '.product-images-main',
        contain:         true,
        pageDots:        false,
        prevNextButtons: false
    });
}


// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

document.querySelectorAll('.contact-form').forEach((form) => {
    form.addEventListener('submit', (event) => {
        event.preventDefault();
        grecaptcha.ready(() => {
            grecaptcha.execute(form.dataset.sitekey, {
                action: 'submit'
            }).then((token) => {

                const submitButton = form.querySelector('[type="submit"]');
                submitButton.classList.add('disabled');
                submitButton.disabled  = true;
                submitButton.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Laden...</span></div>';

                const formData = new FormData(form);
                formData.append('g-recaptcha-response', token);

                const validationAlert = form.parentNode.querySelector('#form-validation');
                validationAlert.classList.add('d-none');
                validationAlert.classList.remove('alert-danger');

                document.querySelectorAll('.invalid-feedback').forEach((element) => {
                    if(!element.classList.contains('d-none')) {
                        element.classList.add('d-none');
                    }
                });

                document.querySelectorAll('.is-invalid').forEach((element) => {
                    element.classList.remove('is-invalid');
                });

                axios.post(form.action, formData).then((response) => {
                    if(response.data.success) {
                        validationAlert.innerHTML = response.data.message;
                        validationAlert.classList.add('alert-success');
                        validationAlert.classList.remove('d-none');

                        form.innerHTML = '';
                    }
                }).catch((exception) => {
                    if(exception.response.data.errors) {
                        for(let error in exception.response.data.errors) {
                            const el = form.querySelector('[name="' + error + '"]') || form.querySelector('#' + error);
                            el.classList.add('is-invalid');
                            if(el.parentNode.querySelector('.d-none') !== null) {
                                el.parentNode.querySelector('.d-none').classList.remove('d-none');
                            }
                        }
                    }

                    submitButton.classList.remove('disabled');
                    submitButton.disabled  = false;
                    submitButton.innerHTML = 'Verstuur bericht';
                });

            });
        });
    });
});

if(window.location.hash) {
    if(window.location.hash === '#scroll-to-section') {
        history.replaceState("", document.title, window.location.pathname + window.location.search);

        if(document.querySelector('.subcategory-container') && window.innerWidth <= 1450) {
            const element = document.querySelector('.subcategory-container');

            window.scrollTo({
                top:      element.getBoundingClientRect().top - document.querySelector('.navbar.navbar-expand-xl').scrollHeight,
                behavior: "smooth"
            });
        }
    }
}

// Filter container (mixitup)
if(document.querySelector('.filter-container')) {
    const filter = mixitup('.filter-container', {
        selectors:  {
            target:  '.filter-item',
            control: '.btn-filter'
        },
        animation:  {
            duration: 300,
            easing:   'cubic-bezier(0.645, 0.045, 0.355, 1)'
        },
        controls:   {
            enable: false
        },
        classNames: {
            block:          '',
            modifierActive: 'active'
        }
    });

    document.querySelectorAll('.btn-filter').forEach((element) => {
        element.addEventListener('click', (e) => {
            e.preventDefault();
            if(document.querySelector('.showcase-item') && !e.currentTarget.classList.contains('control-active')) {
                document.querySelectorAll('.btn-filter.control-active').forEach((el) => el.classList.remove('control-active'));
            }
            e.currentTarget.classList.toggle('control-active');
            updateFilter();
        });
    });

    function updateFilter() {

        let ands = [];
        let ors  = [];
        document.querySelectorAll('.btn-filter.control-active').forEach((element) => {
            if(element.dataset['action'] === 'or') {
                ors.push(element.dataset.toggle);
            } else if(element.dataset['action'] === 'and') {
                ands.push(element.dataset.toggle);
            }
        });

        if(ands.length > 0 && ors.length > 0) {
            for(let u in ors) {
                let cleanValue = '';
                for(let i in ands) {
                    if(i == 0) {
                        cleanValue = ors[u];
                        ors[u]     = ors[u] + ands[i];
                    } else {
                        ors.push(cleanValue + ands[i]);
                    }
                }
            }
        }

        let filterString = '';
        if(ors.length === 0 && ands.length > 0) {
            filterString = ands.join('');
        } else {
            filterString = ors.join(', ');
        }

        filterString = filterString === '' ? 'all' : filterString;

        const elements = Array.from(document.querySelectorAll((filterString !== 'all' ? filterString : '.filter-item')));

        filter.filter(elements);
    }

    if(window.location.hash) {
        const category = window.location.hash.replace(/^#/, '.');
        if(document.querySelector('[data-toggle="' + category + '"]')) {
            document.querySelector('[data-toggle="' + category + '"]').click();
        }
    }
}


document.addEventListener("DOMContentLoaded", (event) => {
    if(document.querySelector('.gridzyGallery')) {
        setTimeout(() => {
            document.querySelectorAll('.gridzyGallery figure').forEach((figure) => {
                figure.classList.remove('visibility-hidden')
            })
        }, 300);

        if(document.querySelector('.gridzyGallery').offsetWidth > 0 || document.querySelector('.gridzyGallery').offsetHeight > 0) {
            let gridzyInstance = new Gridzy(document.querySelector('.gridzyGallery'), {
                spaceBetween:  20,
                layout:        'justified',
                desiredHeight: 400
            });
        }
    }
    if(document.querySelector('button[data-bs-toggle="pill"]')) {
        document.querySelectorAll('button[data-bs-toggle="pill"]').forEach((tabEl) => {
            tabEl.addEventListener('shown.bs.tab', function(event) {
                if(document.querySelector('.gridzyGallery')) {
                    document.querySelectorAll('.gridzyGallery figure').forEach((figure) => {
                        figure.classList.add('visibility-hidden')
                    })
                    if(document.querySelector('.tab-pane.active.show .gridzyGallery')) {
                        setTimeout(() => {
                            new Gridzy(document.querySelector('.tab-pane.active.show .gridzyGallery'), {
                                spaceBetween:  20,
                                layout:        'justified',
                                desiredHeight: 400
                            });
                        }, 1);
                    }
                    setTimeout(() => {
                        document.querySelectorAll('.gridzyGallery figure').forEach((figure) => {
                            figure.classList.remove('visibility-hidden')
                        })
                    }, 300);
                }
            });
        })
    }
});


// Add and remove class to nav on scroll
if(document.querySelector('nav')) {
    let scrollpos      = window.scrollY;
    const header       = document.querySelector("nav");
    const navUtility   = document.querySelector('.nav-utility');
    const headerHeight = navUtility.offsetHeight;

    const addClassOnScroll    = () => header.classList.add("navbar-shrink");
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink");

    window.addEventListener('scroll', () => {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            header.style.top = 0;
            addClassOnScroll();
        } else {
            header.style.top = (headerHeight - window.scrollY) + 'px';
            removeClassOnScroll();
        }
    });

    window.dispatchEvent(
        new Event('scroll')
    );
}

// Modulobox
var modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth:      1440,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', function(gallery, index) {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', function(gallery, index) {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});